//Statuses Constants
export const PENDING = "Pending";
export const CURRENT = 'Current';
export const FUTURE = 'Future';
export const PROCESSED = "Processed";
export const COMPLETED = "Completed";

//Invoices constants
export const INVOICE_TYPE_INVOICE = "Invoice";
export const INVOICE_TYPE_ORDER = "Order";
export const INVOICE_STATUS_DRAFT = "Draft";
export const INVOICE_STATUS_SENT = "Sent";
export const INVOICE_STATUS_ARCHIVED_OR_INVOICED = "Archived/Invoiced";
export const INVOICE_STATUS_PENDING = "Pending";
export const PAYMENT_TERM_BETALES_INDEN = "Betales inden";
export const DK_STANDARD_LAYOUT = "DK standard template";
export const PERSON_NAME_MERGE_TAG = "[person_name]";
export const RESALE = "resale";
export const NEW_SALE = "new_sale";
export const WIN_BACK = "win_back";
export const TRANSFER_MEMBERSHIP = "Transfer Membership";
export const DUPLICATE_MEMBERSHIP = "Duplicate Membership";
export const TRANSFER_NOW = "Transfer Now";
export const TRANSFER_LATER_CANCEL_NOW = "Transfer Later & Cancel Now"
export const TRANSFER_LATER = "Transfer Later"
export const PRODUCT_TYPE_F5 = "F5";
export const INVOICE_STATUS_FAILED = "Failed";

//E-conomic constants
export const ECONOMIC_BASE_URL = "https://restapi.e-conomic.com";
export const DENMARK = "Denmark";
export const SWEDEN = "Sweden";
export const COUNTRY_CODE_DENMARK = "DK";

//Module names
export const MODULE_FINANCE = "Finance";
export const MODULE_CHANGE_MEMBER_GROUP = "Change Member Group";
export const MODULE_TRANSFER_MEMBERSHIP = "Transfer Membership";
export const MODULE_CLIENT_RETENTION = "Client Retention";
//Person Group Change
export const PRODUCT_TYPE_NETWORK_GROUP = [1, 12];
export const CLOSED_LOST = "closed:lost";
export const CLOSED_WON = "closed:won";
export const OPEN = "open";
export const PLANNED_ACTION = "planned_action";
export const FOLLOW_UP = "follow_up";
export const EDIT = "edit"
export const ADD = "add"
export const VIEW = "view";
export const MULTIPLE_CHOICE = "Multiple Choice";
export const TEXT_ONLY = "text_only";
export const SINGLE_CHOICE = "Single Choice";
export const MISSED_CALL = "missed_call";
export const COMPLETED_CALL = "completed_call";
export const SUCCESS = "Success";
export const APPROVED = 'Approved';
export const CANCEL_PURCHASE = 'Cancel Purchase';
export const REVIEW = 'Review';
export const DELAY_TRANSFER = 'Delay Transfer';
export const DEFAULT_PAGE_SIZE = 100;
export const NOT_DEFINED = "N/A";
export const TENTATIVE = 'Tentative';
export const DECLINED = 'Declined';
export const ACCEPTED = 'Accepted';
export const REJECTED = 'Rejected';
export const PRIVATE = 'Private';
export const PUBLIC = 'Public';
export const UNKNOWN = 'Unknown';
export const OVERDUE_TODAY = 'overdue_today';
export const SALE_REP_NEW_REASON = "salesrep_reason_new";
export const WIN_BACK_TYPE = "winback";
export const PAUSE = "pause";
export const ONGOING = "ongoing";
export const EVENTS_OVERVIEW = "events_overview";
export const RESALE_OVERVIEW = "resale_overview";

// Status options for dropdown
export const statusOptions = {
    pending_review: 'Pending',
    approved: 'approved',
    order: 'order',
    delivered: 'delivered',
    cancelled: 'Cancelled'
};

export const NOT_APPLICABLE = "N/A";

export const COUNTRIES = [
  { value: "", label: "All" },
  { value: "Denmark", label: "Denmark" },
  { value: "Sweden", label: "Sweden" },
];

export const REGIONS = {
  Denmark: [
    "Hellerup",
    "Aarhus",
    "Aalborg",
  ],
  Sweden: [
    "Stockholm",
    "Göteborg",
    "Örebro",
    "Luleå",
    "Malmö",
    "Linköping",
    "Sundsvall",
    "Umeå",
    "Jönköping",
    "Skellefteå"
  ]
};

// Define the drag item type
export const DND_ITEM_TYPE = 'column';

// constants.js
export const EMAIL_STATUSES = [
  { label: "All", value: "" },
  { label: "Draft", value: "Draft" },
  { label: "Pending", value: "Pending" },
  { label: "Sent", value: "Sent" },
];

export const DK_CITIES = ["CPH", "Aarhus"];

export function getEconomicDocumentDraftUrl(draftNumber, documentType) {
    if (documentType === INVOICE_TYPE_ORDER) {
        return `${ECONOMIC_BASE_URL}/orders/drafts/${draftNumber}/pdf`;
    } else {
        return `${ECONOMIC_BASE_URL}/invoices/drafts/${draftNumber}/pdf`;
    }
}

export function getEconomicDocumentSentUrl(invoiceNumber, documentType) {
    if (documentType === INVOICE_TYPE_ORDER) {
        return `${ECONOMIC_BASE_URL}/orders/sent/${invoiceNumber}/pdf`;
    } else {
        return `${ECONOMIC_BASE_URL}/invoices/booked/${invoiceNumber}/pdf`;
    }
}

export const MONTHS = [
    {
        name: 'January',
        value: 1
    },
    {
        name: 'February',
        value: 2
    },
    {
        name: 'March',
        value: 3
    },
    {
        name: 'April',
        value: 4
    },
    {
        name: 'May',
        value: 5
    },
    {
        name: 'June',
        value: 6
    },
    {
        name: 'July',
        value: 7
    },
    {
        name: 'August',
        value: 8
    },
    {
        name: 'September',
        value: 9
    },
    {
        name: 'October',
        value: 10
    },
    {
        name: 'November',
        value: 11
    },
    {
        name: 'December',
        value: 12
    },
];

export const ACTION_STATUS_COLORS = {
    'Accepted': 'green',
    'Pending': 'gray',
    'Declined': '#8B0000',
    'Tentative': '#FFD700',
    'FollowUp': '#DB6669'
};

export const RECEIVER_TYPE_OPTIONS = [
    {
        label: "Send to Receiver email",
        key: "receiver"
    },
    {
        label: "Send to Bookkeeper",
        key: "bookkeeper"
    },
    {
        label: "Send to both",
        key: "both"
    }
];

export const ATTENDING_STATUSES = [
    {
        title: "Attending",
        value: "attending",
    },
    {
        title: "Not Attending",
        value: "not_attending",
    },
    {
        title: "Tentative",
        value: "tentative",
    },
    {
        title: "Unknown",
        value: "unknown",
    },
];

export const EVENT_OVERVIEW_TAB_LIST = [
    {
        name: 'person',
        disabled: false,
        hidden: false,
        backgroundColor: "#f5f5f5",
        color: "#3a3641"
    },
    {
        name: 'event',
        disabled: false,
        hidden: false,
        backgroundColor: "#f5f5f5",
        color: "#3a3641"
    },
    {
        name: 'special case',
        disabled: false,
        hidden: true,
        backgroundColor: 'purple',
        color: '#fff'
    },
    {
        name: 'todo',
        disabled: false,
        hidden: false,
        backgroundColor: "#f5f5f5",
        color: "#3a3641"
    }, {
        name: 'todo history',
        disabled: false,
        hidden: false,
        backgroundColor: "#f5f5f5",
        color: "#3a3641"
    }
];

export function getUserSettings() {
    const user = JSON.parse(localStorage.getItem("user"));
    const userMeta = JSON.parse(localStorage.getItem("userMeta"));

    return {"user": user, "userMeta": userMeta};
}



